import { createRoot } from "react-dom/client";
// shell-chrome.css is NOT imported here: tailwind.css pulls it in via
// `@import ... layer(base)`. Imported as JS it would land unlayered, and
// unlayered CSS outranks every cascade layer regardless of specificity — so the
// chrome reset would silently beat all Tailwind utilities.
import "./shadow-probe.css";
import "./tailwind.css";
import { initializeNewRelic, initializeUserpilot } from "./observability";
import { ShellApp } from "./shell/ShellApp";

void initializeNewRelic().catch((error: unknown) => {
  console.error("New Relic browser agent initialization failed.", error);
});

void initializeUserpilot().catch((error: unknown) => {
  console.error("Userpilot initialization failed.", error);
});

const rootElement = document.querySelector<HTMLElement>("#root");

if (!rootElement) {
  throw new Error("Shell root element #root was not found.");
}

rootElement.dataset.platformShell = "";
rootElement.hidden = true;

createRoot(rootElement).render(<ShellApp rootElement={rootElement} />);
